export default __webpack_public_path__ + "static/media/hotspots.03555e89.png";